import React, { useContext, useState, useEffect, useMemo, useLayoutEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SchedulingComponent from '../../components/SchedulingComponent';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { SchedulingStatus } from '../../api/scheduling';
import { serverDate } from '../../utils/date';
import getConfigs from '../../utils/config';
import { RouteContext } from '../../context/router';
import { getDateFormatStorage, getDataStorage, filterInputValue } from '../../utils/filterManagementDataStore';
import CallMonitor from '../../components/CallMonitor';

import useStyles from './styles';

import { formatSchedulingStatus } from '../../utils/scheduling';
import { prettyDate, prettyDateTime } from '../../utils/date';
import moment from 'moment';
import { usePermissions } from '../../utils/permissions';
import Button from '@material-ui/core/Button';
import EyeIcon from '@material-ui/icons/RemoveRedEye';

const subRoutes = [
  {
    title: 'Agendados',
    href: '/agendamento/agendados',
  },
  {
    title: 'Na Fila',
    href: '/agendamento/fila',
  },
  {
    title: 'Chamado',
    href: '/agendamento/chamado',
  },
  {
    title: 'Em atendimento',
    href: '/agendamento/atendimento',
  },
  {
    title: 'Todos',
    href: '/agendamento/todos',
  },
];

// normalize order in view
const tabsOrdered = [
  SchedulingStatus.scheduled,
  SchedulingStatus.inLine,
  SchedulingStatus.called,
  SchedulingStatus.inProgress,
  SchedulingStatus.all,
  // SchedulingStatus.rescheduled,
];

const TAB_INDEX_ALL = tabsOrdered.length - 1;

const Scheduling = ({
  getStatus,
  getCallMessages,
  match,
  branches,
  branchesSelector,
  plantsSelector,
  schedulings,
  cancelScheduling,
  updateScheduling,
  loadBranches,
  loadPlants,
  clients,
  loadClients,
  clearSchedulings,
  loadSchedulings,
  findSchedulingByBarcode,
  barcodeScheduling,
  checkInDriver,
  calledScheduling,
  inTransitScheduling,
  getDriver,
  callOfManySchedulings,
  setAdditionalInfoCalled,
  setUpdateDriverPrimaryPhone,
  setUpdateDriverSecondaryPhone,
  schedulingDataToMonitor,
  getSchedulingConfigs,
  schedulingConfigs,
  schedulingTableColumns,
  addSchedulingTableColumns,
  concatToSchedulingTableColumns,
  updateSchedulingConfigColumnVisibility,
  changeSchedulingTableColumnVisibility,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const router = useContext(RouteContext);
  const [schedulingsClone, setSchedulingsClone] = useState([]);
  const [filter, setFilter] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [clientsFiltereds, setClientsFiltereds] = useState([]);
  const [targetPopover, setTargetPopover] = useState(null);
  const [item, setItem] = useState(null);

  const [isEnabledCalled, setEnabledCalled] = useState(!!getConfigs()?.enable_scheduling_called);
  const [isEnabledSendTruck, setEnabledSendTruck] = useState(!!getConfigs()?.enable_send_truck);
  const [isMonitorOpened, setMonitorOpened] = useState(false);

  const [hideDirector, setHideDirector] = useState([]);

  const { scheduling: schedulingPermissions } = usePermissions();

  const ViewIconButton = (item) => (
    <Button
      color='primary'
      variant='contained'
      onClick={() => handleViewScheduling(item.id)}>
      <EyeIcon />
    </Button>
  );

  const setTab = (tab) => {
    history.push(subRoutes[tab].href);
    setCurrentTab(tab);
  };

  const handleNewScheduling = () => router.push('/agendamento/novo');
  const handleViewScheduling = id => router.push(`/agendamento/status/${id}`);
  const handleCancelScheduling = (id, reason) => cancelScheduling({ id, reason });
  const handleUpdateScheduling = (data) => updateScheduling(data);

  const handleDriverCheckin = async data => {
    await checkInDriver(data);
  }

  const updateClients = clients => {
    const result = {};
    for (const client of clients) {
      result[client.value] = { ...client };
    }

    setClientsFiltereds(Object.values(result));
  };

  const filterClientsByDateAndBranch = (clients, date, branches, schedulingsPendings) => {
    if (!date) {
      return clients;
    }

    const dateRaw = serverDate(date);

    const clientsFiltered = clients.filter(client => {
      let filterCondition = client.date === dateRaw;
      if (schedulingsPendings) {
        filterCondition = filterCondition || [SchedulingStatus.inProgress, SchedulingStatus.inLine, SchedulingStatus.delayed].includes(client.status);
      }

      if (Array.isArray(branches) && branches.length > 0) {
        return filterCondition && branches.includes(client.branch);
      }

      return filterCondition;
    });

    return clientsFiltered;
  };


  useEffect(() => {
    return () => {
      clearSchedulings();
    };
  }, [clearSchedulings]);

  useEffect(() => {
    loadBranches();
  }, [loadBranches]);

  useEffect(() => {
    loadPlants(null);
  }, [loadPlants])

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  useEffect(() => {
    getSchedulingConfigs();
  }, [getSchedulingConfigs]);

  useEffect(() => {
    const fetchData = async () => {
      const schedulingId = match.params.id;
      if(!!schedulingId) {
        await getCallMessages(schedulingId);
      }
    }

    if(schedulingPermissions.canCallMonitor){
      fetchData();
    }

  }, [getCallMessages, match, schedulingPermissions.canCallMonitor]);

  useLayoutEffect(() => {
    let newHideDirector = [];

    if (schedulingConfigs.length > 0) {
      schedulingConfigs.forEach((config, index) => {
        let tempArray = {};
        config.columns.forEach((column) => {
          tempArray[column.tableSelector] = !column.isVisible;
        });
        newHideDirector[index] = tempArray;
      });
      setHideDirector(newHideDirector);
    }
  }, [schedulingConfigs]);

  const shouldOmitColumnFromTable = useCallback((selector) => {
    if (hideDirector.length > 0) {
      return hideDirector[currentTab][selector];
    }
    return false;
  }, [hideDirector, currentTab]);

  const columns = useMemo(() => [
    { name: 'Nº agendamento', selector: 'id', sortable: true, omit: false, },
    {
      name: 'Status',
      selector: 'scheduling_status',
      format: row => formatSchedulingStatus(row.scheduling_status),
      sortable: true,
      omit: shouldOmitColumnFromTable('scheduling_status'),
    },
    { name: 'Cliente / Fornecedor', selector: 'client_name', sortable: true, omit: shouldOmitColumnFromTable('client_name'), },
    { name: 'Placa do caminhão', selector: 'truck_plate', sortable: true, omit: shouldOmitColumnFromTable('truck_plate'), },
    { name: 'CNH Motorista', selector: 'driver_document', sortable: true, omit: shouldOmitColumnFromTable('driver_document'), },
    {
      name: 'Nota Fiscal',
      selector: 'scheduling_document_number_serie',
      format: row => `${row.document_number ?? '-' }/${row.serial_number ?? '-'}`,
      sortable: true,
      omit: shouldOmitColumnFromTable('scheduling_document_number_serie'),
    },
    {
      name: 'Data',
      selector: 'scheduling_date',
      format: row => prettyDate(row.scheduling_date),
      sortable: true,
      omit: shouldOmitColumnFromTable('scheduling_date')
    },
    {
      name: 'Período',
      selector: 'time_description',
      cell: row => <div data-tag="allowRowEvents">{
        `${row.time_description} ${moment(row.starts_at, 'HH:mm:ss').format('HH:mm')} ~ ${moment(row.ends_at, 'HH:mm:ss').format('HH:mm')}`
      }</div>,
      sortable: true,
      omit: shouldOmitColumnFromTable('time_description'),
    },
    {
      name: 'Chegada do Motorista',
      selector: 'driver_checkin_date',
      cell: row => <div data-tag="allowRowEvents">{
        `${row.driver_checkin_date ? prettyDateTime(row.driver_checkin_date) : ''}`
      }</div>,
      sortable: true,
      omit: shouldOmitColumnFromTable('driver_checkin_date'),
    },
    {
      name: 'Filial',
      selector: 'branch_name',
      format: row => `${row.branch_name}`,
      sortable: true,
      omit: shouldOmitColumnFromTable('branch_name'),
    },
    {
      name: 'Planta',
      selector: 'plant_name',
      format: row => `${row.plant_name}`,
      sortable: true,
      omit: shouldOmitColumnFromTable('plant_name'),
    },
    {
      name: '',
      maxWidth: '30px',
      cell: row => schedulingPermissions.canView && <ViewIconButton {...row} />,
      omit: false,
    },
  ], [schedulingPermissions.canView, shouldOmitColumnFromTable]);

  useEffect(() => {
    addSchedulingTableColumns(columns);
  }, [addSchedulingTableColumns, columns]);


  useEffect(() => {
    const branchesFiltered = filterInputValue('scheduling_branches');
    if (Array.isArray(branchesFiltered)) {
      setEnabledCalled(false);
      setEnabledSendTruck(false);
      for (const branch of branchesFiltered) {
        const config = branches.filter((v) => v.id === branch.value)[0]?.config;
        if (config?.enable_called) {
          setEnabledCalled(true);
        }
        if (config?.enable_send_truck) {
          setEnabledSendTruck(true);
          break;
        }
      }
    }
  }, [branches]);

  useEffect(() => {
    const indexTab = subRoutes.findIndex(r => r.href === location.pathname);
    if (indexTab >= 0) {
      setCurrentTab(indexTab);
    }
  }, [location, setCurrentTab]);

  useEffect(() => {
     const date = filter?.schedulingDate || getDateFormatStorage("scheduling_date");

    updateClients(
      filterClientsByDateAndBranch(
        clients,
        date,
        filter.branches,
        filter.shouldGetPendings || getDataStorage("schedulings_pendings")
      )
    );

  }, [filter.branches, filter.shouldGetPendings, filter.schedulingDate, clients]);

  useEffect(() => {
    setSchedulingsClone(schedulings);
  }, [schedulings]);

  useEffect(() => {
    const currentBranch = filterInputValue('scheduling_branches');
    const currentPlant = filterInputValue('scheduling_plants');

    let branches = [];
    let plants = [];
    if (Array.isArray(currentBranch) && currentBranch.length > 0) {
      branches = currentBranch.map(item => item.value);
    }
    if (Array.isArray(currentPlant) && currentPlant.length > 0) {
      plants = currentPlant.map(item => item.value);
    }

    const defaults = {
      truckPlate: getDataStorage('scheduling_inputFilterTruckPlate'),
      schedulingDate: getDateFormatStorage('scheduling_date'),
      shouldGetPendings: getDataStorage('schedulings_pendings'),
      client: getDataStorage('scheduling_client')?.value,
      branches,
      plants
    }

    const params = { ...defaults, ...filter };

    if (params.schedulingDate && params.branches.length > 0) {
      loadSchedulings(params);
    } else {
      setSchedulingsClone([]);
    }
  }, [
    filter,
    loadSchedulings
  ]);

  const findBarcode = async (barcode) => {
    if (barcode) {
      await findSchedulingByBarcode(barcode);
    }
  };

  return (
    <div className={classes.root}>
      <CallMonitor
        monitorControl={isMonitorOpened}
        setMonitorOpened={setMonitorOpened}
        schedulingData={{...schedulingDataToMonitor}}
        onCalled={calledScheduling}
        setUpdateDriverPrimaryPhone={setUpdateDriverPrimaryPhone}
        setUpdateDriverSecondaryPhone={setUpdateDriverSecondaryPhone}
        getCallMessages={getCallMessages}
        id={`call-monitor-scheduling-id`}
        data-cy={`call-monitor-scheduling-data-cy`}
      />
      <SchedulingComponent
        setFilter={setFilter}
        setTab={setTab}
        currentTab={currentTab}
        filter={filter}
        enableCalled={isEnabledCalled}
        enableSendTruck={isEnabledSendTruck}
        branches={branchesSelector}
        plants={plantsSelector}
        clients={clientsFiltereds}
        onNewScheduling={handleNewScheduling}
        onViewScheduling={handleViewScheduling}
        onCancelScheduling={handleCancelScheduling}
        onUpdateScheduling={handleUpdateScheduling}
        onConfirmBarcode={handleDriverCheckin}
        schedulings={schedulingsClone}
        searchBarcode={findBarcode}
        barcodeScheduling={barcodeScheduling}
        subRoutes={subRoutes}
        tabsOrdered = {tabsOrdered}
        onCalled={calledScheduling}
        onCallSeveralScheduling={callOfManySchedulings}
        getDriver={getDriver}
        onTransit={inTransitScheduling}
        setAdditionalInfoCalled={setAdditionalInfoCalled}
        schedulingTableColumns={schedulingTableColumns}
        columnsConfig={schedulingConfigs}
        addSchedulingTableColumns={addSchedulingTableColumns}
        concatToSchedulingTableColumns={concatToSchedulingTableColumns}
        item={item}
        setItem={setItem}
        targetPopover={targetPopover}
        setTargetPopover={setTargetPopover}
        updateSchedulingConfigColumnVisibility={updateSchedulingConfigColumnVisibility}
        changeSchedulingTableColumnVisibility={changeSchedulingTableColumnVisibility}
        hideDirector={hideDirector}
        setMonitorOpened={setMonitorOpened}
        getStatus={getStatus}
        getCallMessages={getCallMessages}
        id={`scheduling-component-id`}
        data-cy={`scheduling-component-data-cy`}
      />
    </div>
  );
};

const getSelectedBranchesId = () => {
  let branchesId = [];
  const selectedBranches = getDataStorage('scheduling_branches');
  if (Array.isArray(selectedBranches) && selectedBranches.length > 0) {
    selectedBranches.forEach((branch) => {
      branchesId.push(branch.value);
    });
    return [...new Set(branchesId)];
  }
  return [];
}

const getPlantLabel = (plant) => {
  return `${plant.name} (${plant.branch_name})`;
};

const mapStateToProps = ({
  cargillBranches: { branches },
  plants: { plants },
  scheduling: { schedulings, clients, barcodeScheduling, schedulingTableColumns, schedulingData },
  configs: { schedulingConfigs, configs },
}) => {
  const selectedBranchesIds = getSelectedBranchesId();
  const handleWithConcatObjects = (arrayColumn = [], objectItem = {}) => {
    return arrayColumn?.push(objectItem);
  }
  const branchesSelector = branches.map((branch) => ({
    value: branch.id,
    label: branch.name,
  }));

  return ({
    branches,
    branchesSelector,
    schedulingDataToMonitor: schedulingData,
    plants,
    plantsSelector: plants.filter((plant) => selectedBranchesIds.includes(plant.id_branch)).map((plant) => ({
      value: plant.id,
      label: getPlantLabel(plant),
      branchId: plant.id_branch
    })),
    clients: clients.map(client => ({
      value: client.id,
      label: client.name,
      date: client.scheduling_date,
      status: client.scheduling_status,
      branch: client.id_branch,
    })),
    schedulingConfigs,
    configs,
    schedulingTableColumns,
    barcodeScheduling,


    schedulings: schedulings.reduce((filtered, currentValue) => {

      let index = tabsOrdered.indexOf(currentValue.scheduling_status);

      const mergeTabs = {
        [SchedulingStatus.delayed]: SchedulingStatus.scheduled,
        [SchedulingStatus.rescheduled]: SchedulingStatus.scheduled,
        [SchedulingStatus.transit]: SchedulingStatus.called
      };

      const tabTarget = mergeTabs[currentValue.scheduling_status];

      if (tabTarget) {
         index = tabsOrdered.indexOf(tabTarget);
      }

      const allIndex = TAB_INDEX_ALL;

      filtered[allIndex] = filtered[allIndex] ?? [];
      handleWithConcatObjects(filtered[allIndex], { ...currentValue })

      if (index === -1) {
        console.warn(`Status '${currentValue.scheduling_status}' not found`);
        return filtered;
      }


      filtered[index] = filtered[index] ?? [];
      handleWithConcatObjects(filtered[index], { ...currentValue })
      return filtered;
    }, [])
  });
}

const mapDispatch = (dispatch) => ({
  getStatus: (payload) => dispatch.scheduling.getStatus(payload),
  clearSchedulings: () => dispatch.scheduling.setSchedulings([]),
  loadSchedulings: payload => dispatch.scheduling.loadAsync(payload),
  loadBranches: payload => dispatch.cargillBranches.loadAsync(payload),
  loadPlants: payload => dispatch.plants.loadAsync(payload),
  loadClients: payload => dispatch.scheduling.loadClientsAsync(payload),
  cancelScheduling: payload => dispatch.scheduling.cancelAsync(payload),
  updateScheduling: payload => dispatch.scheduling.updateAsync(payload),
  findSchedulingByBarcode: payload => dispatch.scheduling.findByBarcode(payload),
  checkInDriver: payload => dispatch.scheduling.checkinDriver(payload),
  calledScheduling: payload => dispatch.scheduling.calledAsync(payload),
  inTransitScheduling: payload => dispatch.scheduling.inTransitAsync(payload),
  getDriver: (payload) => dispatch.driver.getDriverByCNHAsyncNoState(payload),
  callOfManySchedulings: (payload) => dispatch.scheduling.calledsAsync(payload),
  setAdditionalInfoCalled: (payload) => dispatch.scheduling.saveAdditionalInfoCalled(payload),
  setUpdateDriverPrimaryPhone: (payload) => dispatch.scheduling.updateDriverPrimaryPhone(payload),
  setUpdateDriverSecondaryPhone: (payload) => dispatch.scheduling.updateDriverSecondaryPhone(payload),
  getCallMessages: (id) => dispatch.scheduling.getCallMessages(id),
  driverResponse: (payload) => dispatch.scheduling.driverResponse(payload),
  updateStatusMessage: (payload) => dispatch.scheduling.updateStatusMessage(payload),
  addSchedulingTableColumns: (payload) => dispatch.scheduling.addSchedulingTableColumns(payload),
  changeSchedulingTableColumnVisibility: (payload) => dispatch.scheduling.changeSchedulingTableColumnVisibility(payload),
  getSchedulingConfigs: () => dispatch.configs.getSchedulingConfigs(),
  setSchedulingConfigs: (payload) => dispatch.configs.setSchedulingConfigs(payload),
  updateSchedulingConfigColumnVisibility: (payload) => dispatch.configs.updateSchedulingConfigColumnVisibility(payload),
  concatToSchedulingTableColumns: (payload) => dispatch.scheduling.concatToSchedulingTableColumns(payload),
});

Scheduling.propTypes = {
  branches: PropTypes.array.isRequired,
  schedulings: PropTypes.array,
  clients: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatch)(withRouter(Scheduling));
